import { observer } from 'mobx-react-lite';

import { Button } from '@gem/ui-kit';

import Menu from './Menu';
import usePresenter from './presenter';

const SaveArticleButton = ({ parent }) => {
  const { presenter, publishButtonRef } = usePresenter({ parent });

  return (
    <>
      <Button
        theme="primary"
        setRef={publishButtonRef}
        isDisabled={presenter.isDisabled}
        onClick={presenter.onClick}
        dataTest="publish"
      >
        {presenter.title}
      </Button>

      {presenter.isShowMenu && (
        <Menu
          parent={presenter}
          reference={publishButtonRef}
        />
      )}
    </>
  );
};

export default observer(SaveArticleButton);
